import { render } from "./user-avatar.vue?vue&type=template&id=10c246a2&ts=true"
import script from "./user-avatar.vue?vue&type=script&lang=ts"
export * from "./user-avatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__